import React from 'react';
export const defaultImage = React.createElement("svg", {
  viewBox: '0 0 200 200',
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink'
}, React.createElement("defs", null, React.createElement("linearGradient", {
  x1: '50%',
  y1: '-116.862%',
  x2: '50%',
  y2: '90.764%',
  id: 'error-block-image-default-a'
}, React.createElement("stop", {
  stopColor: '#72A7FD',
  stopOpacity: 0.207,
  offset: '0%'
}), React.createElement("stop", {
  stopColor: '#72A7FD',
  stopOpacity: 0.115,
  offset: '80.072%'
}), React.createElement("stop", {
  stopColor: '#72A7FD',
  stopOpacity: 0,
  offset: '100%'
})), React.createElement("circle", {
  id: 'error-block-image-default-d',
  cx: 18.823,
  cy: 18.823,
  r: 18.823
}), React.createElement("rect", {
  id: 'error-block-image-default-b',
  x: 3.5,
  y: 9,
  width: 51.429,
  height: 88,
  rx: 4.571
})), React.createElement("g", {
  fill: 'none',
  fillRule: 'evenodd'
}, React.createElement("path", {
  d: 'M73.557.004c19.435-.311 38.696 17.016 51.523 35.287 8.708-10.822 17.127-16.233 25.255-16.233 13.333 0 28.35 14.274 45.053 42.822 1.769 3.024-3.582 7.435-16.054 13.231l-41.322 1.37c-7.343 5.872-31.225.626-69.152 1.234-27.79.445-45.759-1.234-53.908-5.037C3.2 71.143-1.625 68.686.48 65.308 27.371 22.12 51.73.353 73.557.003Zm93.098 49.53a1.125 1.125 0 0 0-.401.072l-.058.023-.07.03-.028.014-.02.01c-.03.015-.059.032-.088.049a2.543 2.543 0 0 0-.568.477l-.067.074c-1.686 1.931-2.904 7.062-2.904 8.985 0 2.283 1.719 4.153 3.898 4.314l.026.001v3.805c0 .39.25.705.56.705.31 0 .56-.316.56-.705l.001-3.88c1.92-.402 3.363-2.148 3.363-4.24 0-2.39-1.882-9.734-4.204-9.734Zm-100-5a1.125 1.125 0 0 0-.331.05l-.035.01-.035.012-.058.023-.07.03-.028.014-.02.01c-.03.015-.059.032-.088.049a2.543 2.543 0 0 0-.568.477l-.067.074c-1.686 1.931-2.904 7.062-2.904 8.985 0 2.212 1.613 4.036 3.695 4.294l.203.02.026.001v3.805c0 .39.25.705.56.705.282 0 .515-.26.555-.6l.006-.105v-3.88c1.92-.402 3.363-2.148 3.363-4.24 0-2.39-1.882-9.734-4.204-9.734ZM52.64 38.348l-.15.008-.149.023-.032.007-.032.008-.078.022-.045.015-.045.016-.06.023-.038.017-.038.017-.058.028-.022.011a2.201 2.201 0 0 0-.323.204l-.05.038-.05.04-.025.02-.025.021a3.742 3.742 0 0 0-.31.294l-.036.04c-.035.037-.07.076-.105.116-.01.012-.02.025-.031.036a3.275 3.275 0 0 0-.081.098l-.063.078c-2.031 2.583-3.48 8.692-3.48 11.027 0 2.636 1.846 4.832 4.292 5.323l.224.04-.064-.012.105.018.103.014v4.618c0 .47.299.85.667.85.337 0 .615-.32.659-.735l.006-.115v-4.618c.18-.023.355-.054.527-.094l.256-.067.196-.06c2.136-.706 3.68-2.75 3.68-5.162 0-2.996-2.383-12.207-5.325-12.207Z',
  transform: 'translate(2.286 22.286)',
  fill: 'url(#error-block-image-default-a)'
}), React.createElement("g", {
  transform: 'rotate(-90 102.429 55.357)'
}, React.createElement("path", {
  d: 'M6.857 0H52a6.857 6.857 0 0 1 6.857 6.857v92A6.857 6.857 0 0 1 52 105.714H6.857A6.857 6.857 0 0 1 0 98.857v-92A6.857 6.857 0 0 1 6.857 0Z',
  fill: '#7EACFF'
}), React.createElement("mask", {
  id: 'error-block-image-default-c',
  fill: '#fff'
}, React.createElement("use", {
  xlinkHref: '#error-block-image-default-b'
})), React.createElement("use", {
  fill: '#377EFF',
  xlinkHref: '#error-block-image-default-b'
}), React.createElement("path", {
  d: 'M11.838 91.8a.64.64 0 0 1 .627.652.64.64 0 0 1-.627.652.64.64 0 0 1-.628-.652c0-.36.281-.651.628-.651Zm-2.858 0a.64.64 0 0 1 .628.652.64.64 0 0 1-.628.652.64.64 0 0 1-.627-.652c0-.36.281-.651.627-.651Zm2.16-2.305a.64.64 0 0 1 .628.652.64.64 0 0 1-.627.651.64.64 0 0 1-.627-.651c0-.36.28-.652.627-.652Zm-2.982-.04a.64.64 0 0 1 .627.651.64.64 0 0 1-.627.652.64.64 0 0 1-.627-.652c0-.36.28-.651.627-.651Zm5.268-.531a.64.64 0 0 1 .628.651.64.64 0 0 1-.628.652.64.64 0 0 1-.627-.652c0-.36.281-.651.627-.651Zm2.858-1.143a.64.64 0 0 1 .627.651.64.64 0 0 1-.627.652.64.64 0 0 1-.628-.652c0-.36.281-.651.628-.651Zm-6.37-.917c.209 0 .377.175.377.39a.384.384 0 0 1-.376.392.384.384 0 0 1-.376-.391c0-.216.168-.391.376-.391Zm3.512-.798.093.007a.644.644 0 0 1 .535.645.64.64 0 0 1-.628.652.64.64 0 0 1-.627-.652c0-.36.281-.652.627-.652Zm5.715 0a.64.64 0 0 1 .627.652.64.64 0 0 1-.627.652.64.64 0 0 1-.627-.652c0-.36.28-.652.627-.652Zm-11.429 0a.64.64 0 0 1 .627.652.64.64 0 0 1-.627.652.64.64 0 0 1-.627-.652c0-.36.28-.652.627-.652Zm-3.261.241c.208 0 .376.175.376.39a.384.384 0 0 1-.376.392.384.384 0 0 1-.377-.391c0-.216.169-.391.377-.391Zm11.833-.812a.64.64 0 0 1 .627.652.64.64 0 0 1-.627.651.64.64 0 0 1-.628-.651c0-.36.281-.652.628-.652Zm-4.851.399c.208 0 .376.175.376.39a.384.384 0 0 1-.376.392.384.384 0 0 1-.377-.391c0-.216.169-.391.377-.391Zm10.313-2.056a.64.64 0 0 1 .628.652.64.64 0 0 1-.628.651.64.64 0 0 1-.627-.651c0-.36.281-.652.627-.652Zm-2.354-.128a.64.64 0 0 1 .627.652.64.64 0 0 1-.627.652.64.64 0 0 1-.628-.652c0-.36.281-.652.628-.652Zm-13.798.311c.207 0 .376.175.376.391a.384.384 0 0 1-.376.391.384.384 0 0 1-.377-.39c0-.217.169-.392.377-.392Zm11.832-.812a.64.64 0 0 1 .628.652.64.64 0 0 1-.628.651.64.64 0 0 1-.627-.651c0-.36.281-.652.627-.652Zm-6.285 0a.64.64 0 0 1 .627.652.64.64 0 0 1-.627.651.64.64 0 0 1-.627-.651c0-.36.28-.652.627-.652Zm3.428 0a.64.64 0 0 1 .627.652.64.64 0 0 1-.627.651.64.64 0 0 1-.627-.651c0-.36.28-.652.627-.652Zm-6.118.24c.208 0 .376.176.376.392a.384.384 0 0 1-.376.39.384.384 0 0 1-.377-.39c0-.216.169-.391.377-.391Zm11.261-2.525a.64.64 0 0 1 .627.651.64.64 0 0 1-.627.652.64.64 0 0 1-.627-.652c0-.36.28-.651.627-.651Zm-3.557.484c.208 0 .376.175.376.391a.384.384 0 0 1-.376.391.384.384 0 0 1-.376-.391c0-.216.168-.391.376-.391Zm-2.478-.555a.64.64 0 0 1 .627.652.64.64 0 0 1-.627.652.64.64 0 0 1-.627-.652c0-.36.28-.652.627-.652Zm-3.512-.26c.208 0 .376.175.376.39a.384.384 0 0 1-.376.392.384.384 0 0 1-.376-.391c0-.216.168-.391.376-.391Zm-2.857 0c.208 0 .376.175.376.39a.384.384 0 0 1-.376.392.384.384 0 0 1-.376-.391c0-.216.168-.391.376-.391Zm-4.571 0c.207 0 .376.175.376.39a.384.384 0 0 1-.376.392.384.384 0 0 1-.377-.391c0-.216.169-.391.377-.391Zm14.898-1.835a.64.64 0 0 1 .628.652.64.64 0 0 1-.628.651.64.64 0 0 1-.627-.651c0-.36.281-.652.627-.652Zm-8.027-.245c.208 0 .377.175.377.39a.384.384 0 0 1-.377.392.384.384 0 0 1-.376-.391c0-.216.169-.391.376-.391Zm6.271-1.349c.208 0 .377.175.377.391a.384.384 0 0 1-.377.391.384.384 0 0 1-.376-.39c0-.217.169-.392.376-.392Zm-11.484-.481c.208 0 .376.175.376.39a.384.384 0 0 1-.376.392.384.384 0 0 1-.376-.391c0-.216.168-.391.376-.391Zm15.103-.972c.208 0 .376.175.376.391a.384.384 0 0 1-.376.391.384.384 0 0 1-.376-.39c0-.217.168-.392.376-.392Zm-9.333-1.404c.208 0 .376.175.376.39a.384.384 0 0 1-.376.392.384.384 0 0 1-.376-.391c0-.216.168-.391.376-.391Zm-6.819-.405c.208 0 .377.175.377.39a.384.384 0 0 1-.377.392.384.384 0 0 1-.376-.391c0-.216.168-.391.376-.391Z',
  fill: '#003CFF',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-c)',
  transform: 'rotate(116 12.367 83.503)'
}), React.createElement("path", {
  stroke: '#FFF',
  strokeWidth: 0.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  d: 'M36.774 5.474H21.523'
}), React.createElement("path", {
  d: 'm67.818 94.025-4.996 3.913m4.996 11.91-4.996-3.912m-1.142 9.145-1.143-6.288m10.71-6.768h-7.262',
  stroke: '#4486FE',
  strokeWidth: 0.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
})), React.createElement("circle", {
  cx: 8.571,
  cy: 8.571,
  r: 8.571,
  transform: 'translate(22.857 142)',
  fill: '#FFCD6B',
  fillRule: 'nonzero'
}), React.createElement("g", {
  transform: 'translate(132.857 124)'
}, React.createElement("mask", {
  id: 'error-block-image-default-e',
  fill: '#fff'
}, React.createElement("use", {
  xlinkHref: '#error-block-image-default-d'
})), React.createElement("use", {
  fill: '#FBBE47',
  fillRule: 'nonzero',
  xlinkHref: '#error-block-image-default-d'
}), React.createElement("circle", {
  fill: '#FFCD6B',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-e)',
  cx: 13.886,
  cy: 15.12,
  r: 18.823
}), React.createElement("circle", {
  fill: '#FFB400',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-e)',
  cx: 23.4,
  cy: 29.057,
  r: 1
}), React.createElement("circle", {
  fill: '#FFB400',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-e)',
  cx: 30.343,
  cy: 29.829,
  r: 1
}), React.createElement("circle", {
  fill: '#FFB400',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-e)',
  cx: 18.771,
  cy: 32.657,
  r: 1.286
}), React.createElement("circle", {
  fill: '#FFB400',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-e)',
  cx: 29.571,
  cy: 25.971,
  r: 1.286
}), React.createElement("circle", {
  fill: '#FFB400',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-e)',
  cx: 19.286,
  cy: 7.971,
  r: 1.286
}), React.createElement("circle", {
  fill: '#FFB400',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-e)',
  cx: 26.486,
  cy: 5.914,
  r: 1.286
}), React.createElement("circle", {
  fill: '#FFB400',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-e)',
  cx: 11.057,
  cy: 6.943,
  r: 1
}), React.createElement("circle", {
  fill: '#FFB400',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-e)',
  cx: 30.086,
  cy: 15.686,
  r: 1.286
}), React.createElement("circle", {
  fill: '#FFB400',
  fillRule: 'nonzero',
  mask: 'url(#error-block-image-default-e)',
  cx: 22.886,
  cy: 14.657,
  r: 1
})), React.createElement("path", {
  d: 'm87.429 135.123 6.591-9.378v-.08h-5.99v-2.559h10.038v1.787l-6.44 9.254v.082h6.56v2.557h-10.76v-1.663Zm12.185-5.889 4.948-7.047v-.056h-4.498v-1.917h7.536v1.34l-4.849 6.942v.059h4.923v1.92h-8.06v-1.24Zm10.345.702 3.708-5.274v-.045h-3.372v-1.437h5.648v1.003l-3.628 5.206v.045H116v1.438h-6.041v-.936Z',
  fill: '#FFF',
  fillRule: 'nonzero'
})));